import { put, take } from "redux-saga/effects";

import {
  requestContentMenu,
  REQUEST_CONTENT_MENU_SUCCESS
} from "../../actions/contentMenu";
import { store } from "../../store";
import { setPage } from "../../actions/page";

export function* fetchContextMenu(locale) {
  // Fetch menu
  yield put(requestContentMenu(locale));
  yield take(REQUEST_CONTENT_MENU_SUCCESS);

  // Select locale
  let state = store.getState();

  // No page is set yet and no page has been requested by url.
  if (
    state.page === undefined ||
    state.page.data === undefined ||
    state.page.data === ""
  ) {
    if (
      state.contentMenu &&
      state.contentMenu.data &&
      state.contentMenu.data.links &&
      state.contentMenu.data.links.home &&
      state.contentMenu.data.links.home.link &&
      state.locale &&
      state.locale.data
    ) {
      yield put(setPage(""));
    }
  } else {
    yield put(setPage(state.page.data));
  }
}



// WEBPACK FOOTER //
// ./src/redux/sagas/controllers/fetchContextMenu.js